var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04819 10.3195C1.75412 10.0092 2.566 10.381 2.85287 11.1455L4.49725 15.1439H5.02553V4.26892C5.02553 3.44392 5.64897 2.76892 6.41069 2.76892C7.17288 2.76892 7.79584 3.44392 7.79584 4.26892V11.3822L8.48866 11.3939V2.01892C8.48866 1.19392 9.11209 0.518921 9.87381 0.518921C10.6379 0.518921 11.259 1.19392 11.259 2.01892V11.3822L11.9504 11.3939V3.51892C11.9504 2.69392 12.5738 2.01892 13.3355 2.01892C14.0977 2.01892 14.7207 2.69392 14.7207 3.51892V12.1322L15.4135 12.1439V6.51892C15.4135 5.69392 16.0369 5.01892 16.7987 5.01892C17.5613 5.01892 18.1847 5.69392 18.1847 6.51892V16.6439C18.1847 20.197 16.4443 24.5189 10.2629 24.5189C8.35038 24.5189 6.54006 24.1908 5.54444 23.5345C4.9201 23.123 4.38299 22.5924 3.96381 21.9731C3.65058 21.511 3.39848 21.0103 3.21381 20.4835L0.285999 12.2738C-0.00040704 11.5092 0.342249 10.6303 1.04819 10.3195Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoting);
export default __webpack_public_path__ + "static/media/voting.bb9f1af3.svg";
export { ForwardRef as ReactComponent };